export const currentUserKeys = {
  me: ['me'] as const,
  userPermissions: ['user-permissions'] as const,
  exportPermissions: ['export-permissions'] as const
};
